import { Pipe, PipeTransform } from '@angular/core'

interface Options {
    day: string
    month: string
    year: string
}

@Pipe({
    name: 'localeDate',
})
export class LocaleDatePipe implements PipeTransform {
    transform(date: string): unknown {
        if (!date) {
            return 'Sem data definida'
        }
        return new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).format(new Date(date))
    }
}
